const OWNER_QR_PATH = '/studentplayground/api/teacher/work-with-children-qr/';
const PDF_CONTENT_TYPE = 'application/pdf';
export const TEACHER_WORK_QR_ACCEPT = 'image/jpeg,image/png,image/webp,application/pdf,.pdf';

async function responseError(response, fallbackError) {
    const payload = await response.json().catch(() => ({}));
    return new Error(payload.error || fallbackError);
}

export async function uploadTeacherWorkQrCode({
    apiBase,
    token,
    file,
    fetchImpl = fetch,
    fallbackError = 'Nepavyko įkelti QR kodo.'
}) {
    const formData = new FormData();
    formData.append('qrCode', file);

    const response = await fetchImpl(`${apiBase}${OWNER_QR_PATH}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || fallbackError);
    return result;
}

export async function fetchTeacherWorkQrCode({
    apiBase,
    token,
    teacherId,
    fetchImpl = fetch,
    fallbackError = 'Nepavyko parodyti QR kodo.'
}) {
    const path = teacherId === undefined || teacherId === null
        ? OWNER_QR_PATH
        : `/studentplayground/api/admin/teachers/${encodeURIComponent(teacherId)}/work-with-children-qr/`;
    const response = await fetchImpl(`${apiBase}${path}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw await responseError(response, fallbackError);
    return response.blob();
}

export function reserveTeacherWorkQrPdfWindow(
    contentType,
    openWindow = () => window.open('', '_blank')
) {
    if (contentType !== PDF_CONTENT_TYPE) return null;

    const previewWindow = openWindow();
    if (!previewWindow) {
        throw new Error('Naršyklė užblokavo PDF peržiūros langą. Leiskite iššokančius langus ir bandykite dar kartą.');
    }
    previewWindow.opener = null;
    return previewWindow;
}

export function presentTeacherWorkQrFile(
    blob,
    {
        pdfWindow = null,
        createObjectURL = value => URL.createObjectURL(value),
        revokeObjectURL = value => URL.revokeObjectURL(value)
    } = {}
) {
    const objectUrl = createObjectURL(blob);
    if (blob.type === PDF_CONTENT_TYPE) {
        if (!pdfWindow) {
            revokeObjectURL(objectUrl);
            throw new Error('Nepavyko atidaryti PDF peržiūros lango.');
        }
        pdfWindow.location.href = objectUrl;
        return { kind: 'pdf', objectUrl };
    }

    if (pdfWindow && typeof pdfWindow.close === 'function') pdfWindow.close();
    return { kind: 'image', objectUrl };
}

export async function loadTeacherWorkQrPreview({
    apiBase,
    token,
    contentType,
    teacherId,
    fetchImpl = fetch,
    openWindow = () => window.open('', '_blank'),
    createObjectURL = value => URL.createObjectURL(value),
    revokeObjectURL = value => URL.revokeObjectURL(value),
    fallbackError
}) {
    const pdfWindow = reserveTeacherWorkQrPdfWindow(contentType, openWindow);
    try {
        const blob = await fetchTeacherWorkQrCode({
            apiBase,
            token,
            teacherId,
            fetchImpl,
            fallbackError
        });
        return presentTeacherWorkQrFile(blob, {
            pdfWindow,
            createObjectURL,
            revokeObjectURL
        });
    } catch (error) {
        if (pdfWindow && typeof pdfWindow.close === 'function') pdfWindow.close();
        throw error;
    }
}
